/**
 * Tiny info tooltip — wrap any label or input with a help-icon trigger.
 *
 * Usage:
 *   <Label>Region <InfoTip>Region drives base cost & productivity multipliers.</InfoTip></Label>
 */
import React, { useState } from 'react';
import { Info } from 'lucide-react';

export default function InfoTip({ children, side = 'top' }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-block ml-1 align-middle"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="text-slate-400 hover:text-slate-700 focus:outline-none align-middle"
        aria-label="Info"
        tabIndex={0}
      >
        <Info className="h-3.5 w-3.5 inline" />
      </button>
      {open && (
        <span
          className={`absolute z-50 ${side === 'top' ? 'bottom-full mb-1.5' : 'top-full mt-1.5'} left-1/2 -translate-x-1/2 w-64 max-w-[16rem] bg-slate-900 text-white text-xs rounded-md shadow-lg px-2.5 py-2 normal-case font-normal leading-snug`}
          role="tooltip"
        >
          {children}
        </span>
      )}
    </span>
  );
}
